import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=2db5a16b&"
import script from "./Title.controller.js?vue&type=script&lang=js&"
export * from "./Title.controller.js?vue&type=script&lang=js&"
import style0 from "./Title.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports